import{useSelector}from'react-redux';const useBrand=()=>{return useSelector(state=>state.brand||'');};export default useBrand;